import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, matchPath } from 'react-router-dom';
import { LayoutProvider } from './layout/context/LayoutContext';
import Layout from './layout/layout';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './styles/layout/layout.scss';

import routes from "./routes";
import Login from './components/login/login';
import { Toast } from 'primereact/toast';
import { LoadingProvider } from './components/loading/loadingContext';
import { ToastProvider } from './components/Toast';
import { DialogProvider } from './components/Dialog';
import NotFound from './pages/Not-Found';
import AssignmentEdit from './pages/asset/assignment/assignment-edit';
import AssignmentList from './pages/asset/assignment/assignment-list';
import AssignmentView from './pages/asset/assignment/assignment-view';
import AssignmentLogin from './pages/asset/assignment/assignment-login';
import useAuth from './utils/useAuth';
import SessionTimeout from './components/login/session-timeout';
import { SessionListener } from './utils/SessionListener';
import SessionManagerWrapper from './utils/SessionManagerWrap';

const AppContent = () => {
    const location = useLocation();
    const toast = useRef<Toast>(null);
    // List of routes that should hide the navbar
    const hideNavbarRoutes = ["/login", "/asset/assignment/:param", "/asset/assignment/edit/:param", "/asset/assignment/login/:param", "/session-timeout"];

    // Check if current path matches any in the hideNavbarRoutes list
    const shouldHideNavbar = hideNavbarRoutes.some(route =>
        matchPath({ path: route, end: true }, location.pathname)
    );

    return (
        <LoadingProvider>
            <DialogProvider>
                <ToastProvider>
                    <LayoutProvider>
                        {shouldHideNavbar ? (
                            <Routes>
                                <Route path="/login" element={<Login />} />
                                <Route path="/session-timeout" element={<SessionTimeout />} />
                                <Route path="/asset/assignment/:param" element={<AssignmentView />} />
                                <Route path="/asset/assignment/edit/:param" element={<AssignmentEdit />} />
                                <Route path="/asset/assignment/login/:param" element={<AssignmentLogin />} />
                            </Routes>
                        ) : (
                            <Layout>
                                <Routes>
                                    <Route path="/" element={<Navigate to="/login" replace />} />
                                    {routes.map(({ path, element }, index) => (
                                        <Route key={index} path={path} element={element} />
                                    ))}
                                    <Route path="*" element={<NotFound />} />
                                </Routes>
                            </Layout>
                        )}
                    </LayoutProvider>
                </ToastProvider>
            </DialogProvider>
        </LoadingProvider>
    );
};

export default function App() {
    const isAuthenticated = useAuth();
    return (
        <Router>
            {/* {isAuthenticated && <TokenRefresherComponent />} */}
            <SessionManagerWrapper>
                <SessionListener />
                <AppContent />
            </SessionManagerWrapper>
        </Router>
    );
}
